/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown> }} Progress_Consistency_Count_UnplannedInputs */

const en_us2_progress_consistency_count_unplanned = /** @type {(inputs: Progress_Consistency_Count_UnplannedInputs) => LocalizedString} */ (i) => {
	if ((i?.done === 1 || i?.done === "1")) return /** @type {LocalizedString} */ (`1 workout`);
	return /** @type {LocalizedString} */ (`${i?.done} workouts`)
	
};

const pt_br2_progress_consistency_count_unplanned = /** @type {(inputs: Progress_Consistency_Count_UnplannedInputs) => LocalizedString} */ (i) => {
	if ((i?.done === 1 || i?.done === "1")) return /** @type {LocalizedString} */ (`1 treino`);
	return /** @type {LocalizedString} */ (`${i?.done} treinos`)
	
};

const es_419_progress_consistency_count_unplanned = /** @type {(inputs: Progress_Consistency_Count_UnplannedInputs) => LocalizedString} */ (i) => {
	if ((i?.done === 1 || i?.done === "1")) return /** @type {LocalizedString} */ (`1 entrenamiento`);
	return /** @type {LocalizedString} */ (`${i?.done} entrenamientos`)
	
};

const pt_pt2_progress_consistency_count_unplanned = /** @type {(inputs: Progress_Consistency_Count_UnplannedInputs) => LocalizedString} */ (i) => {
	if ((i?.done === 1 || i?.done === "1")) return /** @type {LocalizedString} */ (`1 treino`);
	return /** @type {LocalizedString} */ (`${i?.done} treinos`)
	
};

const fr_fr2_progress_consistency_count_unplanned = /** @type {(inputs: Progress_Consistency_Count_UnplannedInputs) => LocalizedString} */ (i) => {
	if ((i?.done === 0 || i?.done === "0")) return /** @type {LocalizedString} */ (`0 séance`);
	if ((i?.done === 1 || i?.done === "1")) return /** @type {LocalizedString} */ (`1 séance`);
	return /** @type {LocalizedString} */ (`${i?.done} séances`)
	
};

const de_de2_progress_consistency_count_unplanned = /** @type {(inputs: Progress_Consistency_Count_UnplannedInputs) => LocalizedString} */ (i) => {
	if ((i?.done === 1 || i?.done === "1")) return /** @type {LocalizedString} */ (`1 Training`);
	return /** @type {LocalizedString} */ (`${i?.done} Trainings`)
	
};

const it_it2_progress_consistency_count_unplanned = /** @type {(inputs: Progress_Consistency_Count_UnplannedInputs) => LocalizedString} */ (i) => {
	if ((i?.done === 1 || i?.done === "1")) return /** @type {LocalizedString} */ (`1 allenamento`);
	return /** @type {LocalizedString} */ (`${i?.done} allenamenti`)
	
};

/**
* | done | output |
* | --- | --- |
* | "1" | "1 workout" |
* | * | "{done} workouts" |
*
* @param {Progress_Consistency_Count_UnplannedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_consistency_count_unplanned = /** @type {((inputs: Progress_Consistency_Count_UnplannedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Consistency_Count_UnplannedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_consistency_count_unplanned(inputs)
	if (locale === "es-419") return es_419_progress_consistency_count_unplanned(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_consistency_count_unplanned(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_consistency_count_unplanned(inputs)
	if (locale === "de-DE") return de_de2_progress_consistency_count_unplanned(inputs)
	if (locale === "it-IT") return it_it2_progress_consistency_count_unplanned(inputs)
	return en_us2_progress_consistency_count_unplanned(inputs)
});
export { progress_consistency_count_unplanned as "progress.consistency_count_unplanned" }